import { render, staticRenderFns } from "./NewFeed.vue?vue&type=template&id=1c0ad8f5"
import script from "./NewFeed.vue?vue&type=script&lang=js"
export * from "./NewFeed.vue?vue&type=script&lang=js"
import style0 from "./NewFeed.vue?vue&type=style&index=0&id=1c0ad8f5&prod&lang=scss"
import style1 from "./NewFeed.vue?vue&type=style&index=1&id=1c0ad8f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports